import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { LayoutComponent as MasterLayoutComponent, LayoutConfig } from '@portal/layout';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { CONFIG } from '@bizflex/data-access';
import { Subject, takeUntil } from 'rxjs';
import { CONTACT_US_URL, HOME_PAGE_FLEXIPAY_URL, HOME_PAGE_SME_URL } from '@portal/data-access';

@Component({
  selector: 'bizflex-error-page-layout',
  standalone: true,
  imports: [MasterLayoutComponent, RouterOutlet],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroy$ = new Subject<void>();
  protected readonly layoutConfig: LayoutConfig = {
    title: CONFIG.APP_TITLE,
    page: CONFIG.PAGE_TITLE,
    hideHeroBanner: true,
  };
  protected readonly contactUsPage = CONTACT_US_URL;
  protected homePage = HOME_PAGE_SME_URL;

  ngOnInit(): void {
    this.route.queryParamMap.pipe(takeUntil(this.destroy$)).subscribe(qpm => {
      const utm = qpm.get('utm_source');
      this.homePage = utm === 'lead_reminder' ? HOME_PAGE_FLEXIPAY_URL : HOME_PAGE_SME_URL;

      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
